"use client";

import { useState } from "react";
import { Plus, Route, Receipt, KeyRound, Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { BlockFormSheet } from "@/components/blocks/block-form-sheet";
import { ExpenseFormSheet } from "@/components/expenses/expense-form-sheet";
import { CodeFormSheet } from "@/components/codes/code-form-sheet";
import { QuickAddPhotoSheet } from "@/components/blocks/quick-add-photo-sheet";
import { isNativePlatform } from "@/lib/issue-photo";

export function QuickAddMenu() {
  const [blockSheetOpen, setBlockSheetOpen] = useState(false);
  const [expenseSheetOpen, setExpenseSheetOpen] = useState(false);
  const [codeSheetOpen, setCodeSheetOpen] = useState(false);
  const [photoSheetOpen, setPhotoSheetOpen] = useState(false);

  const isNative = isNativePlatform();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="h-9 w-10 p-0">

            <Plus className="h-4 w-4" />
            <span className="sr-only">Quick add menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          <DropdownMenuItem
            onClick={() => setBlockSheetOpen(true)}
            className="py-3 text-base"
          >
            <Route className="mr-3 h-5 w-5" />
            Add Block
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => setExpenseSheetOpen(true)}
            className="py-3 text-base"
          >
            <Receipt className="mr-3 h-5 w-5" />
            Add Expense
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => setCodeSheetOpen(true)}
            className="py-3 text-base"
          >
            <KeyRound className="mr-3 h-5 w-5" />
            Add Access Code
          </DropdownMenuItem>
          {isNative && (
            <DropdownMenuItem
              onClick={() => setPhotoSheetOpen(true)}
              className="py-3 text-base"
            >
              <Camera className="mr-3 h-5 w-5" />
              Add Photo
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Sheets - use hidden triggers since we control open state */}
      <BlockFormSheet
        mode="create"
        open={blockSheetOpen}
        onOpenChange={setBlockSheetOpen}
        trigger={<span className="hidden" />}
      />

      <ExpenseFormSheet
        mode="create"
        open={expenseSheetOpen}
        onOpenChange={setExpenseSheetOpen}
        trigger={<span className="hidden" />}
      />

      <CodeFormSheet
        open={codeSheetOpen}
        onOpenChange={setCodeSheetOpen}
      />

      {isNative && (
        <QuickAddPhotoSheet
          open={photoSheetOpen}
          onOpenChange={setPhotoSheetOpen}
        />
      )}
    </>
  );
}
